import * as React from "react";
import { AddressRequirement } from "../Search/types";
import { LocationSearchModal } from "../Search/LocationSearchModal";
import { safeReloadPage } from "src/lib/common";
import { SimpleDialog } from "../../Common/SimpleDialog";

/**
 * The UI for the zip code display in the header
 * @param props
 * @returns
 */
export const ZipDisplay: React.FunctionComponent<{
  address: IDeliveryAddress;
  editHandle: () => void;
}> = (props) => {
  if (props.address.LocationId === 0 && props.address.PostalCode !== "") {
    return (
      <>
        <div className="address-panel">
          <span className="delivery-label">Delivery To:</span>
          <span>{props.address.PostalCode} </span>
          <span
            onClick={props.editHandle}
            className="i-edit"
            title="edit delivery location"
          ></span>
        </div>
      </>
    );
  }

  return <></>;
};

/**
 * * Displays the delivery address info (zip code) in the header
 * * wires up the icon to open a dialog to edit the delivery location.
 * Also wires up legacy elements to open the dialog using a class name of `hospital-search-legacy`
 * @param props
 * @returns
 */
export const ZipDisplayComponent: React.FunctionComponent<{
  address: IDeliveryAddress;
}> = (props) => {
  const [dialogVisible, setDialogVisible] = React.useState(false);

  React.useEffect(() => {
    // wires up click events for any legacy search elements left on the page.
    const buttons = document.getElementsByClassName(
      "hospital-search-legacy",
    ) as HTMLCollectionOf<HTMLElement>;

    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];

      button.addEventListener("click", (e) => {
        e.preventDefault();
        setDialogVisible(true);
      });
    }
  }, []);
  const requirement = AddressRequirement.ZipCode;

  function handleLocationSelected(): void {
    safeReloadPage();
  }

  return (
    <>
      <ZipDisplay
        address={props.address}
        editHandle={() => {
          setDialogVisible(true);
        }}
      />
      <SimpleDialog
        open={dialogVisible}
        title="Select Delivery Type"
        onClose={() => setDialogVisible(false)}
      >
        <LocationSearchModal
          addressRequirement={requirement}
          onLocationSelected={handleLocationSelected}
          onZipSelected={handleLocationSelected}
        />
      </SimpleDialog>
    </>
  );
};
